import React from "react";

const DAYS_TO_SHOW = 30;

const AgendaView = ({
  currentDate,
  getEventsForDate,
  getColorForEvent,
  onOpenEditEvent,
  onNavigateToDay,
}) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const days = Array.from({ length: DAYS_TO_SHOW }, (_, i) => {
    const d = new Date(currentDate);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + i);
    return d;
  });

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const formatTime = (t) => {
    if (!t) return "";
    const [h, m] = t.split(":").map(Number);
    const h12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
    const ampm = h < 12 ? "AM" : "PM";
    return `${h12}:${m.toString().padStart(2, "0")} ${ampm}`;
  };

  return (
    <div className="divide-y divide-gray-100">
      {days.map((day, idx) => {
        const evts = getEventsForDate(day);
        const isToday = day.toDateString() === today.toDateString();
        const isWeekend = day.getDay() === 0 || day.getDay() === 6;

        return (
          <div key={idx} className={`py-3 ${evts.length === 0 ? "opacity-40" : ""}`}>
            <div
              className={`flex items-center gap-2 mb-2 cursor-pointer select-none touch-manipulation`}
              onClick={() => onNavigateToDay(day)}
            >
              {isToday && (
                <span className="bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full font-semibold">Today</span>
              )}
              <span className={`text-sm font-semibold ${isToday ? "text-blue-600" : isWeekend ? "text-purple-600" : "text-gray-700"}`}>
                {dayNames[day.getDay()]}, {monthNames[day.getMonth()]} {day.getDate()}
              </span>
            </div>

            {evts.length === 0 ? (
              <p className="text-xs text-gray-400 pl-2">No events</p>
            ) : (
              <div className="space-y-1.5 pl-2">
                {evts
                  .sort((a, b) => {
                    if (a.all_day && !b.all_day) return -1;
                    if (!a.all_day && b.all_day) return 1;
                    return (a.time || "").localeCompare(b.time || "");
                  })
                  .map((event) => {
                    const c = getColorForEvent(event);
                    const isGradient = c.startsWith("linear-gradient");
                    const timeLabel = event.all_day ? "All day" : formatTime(event.time);
                    return (
                      <div
                        key={event.id}
                        className="flex items-center gap-2 cursor-pointer hover:opacity-80 touch-manipulation"
                        onClick={() => !event._virtual && onOpenEditEvent(event)}
                      >
                        <div
                          className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                          style={isGradient ? { background: c } : { backgroundColor: c }}
                        />
                        <span className="text-xs text-gray-500 w-16 flex-shrink-0 tabular-nums">{timeLabel}</span>
                        <span className="text-sm truncate" style={event.canceled ? { textDecoration: 'line-through', color: '#991b1b' } : { color: '#1f2937' }}>{event.title}</span>
                      </div>
                    );
                  })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AgendaView;
